import { ModelInputFileAttachmentType } from '@scale/shared/types/chat';

/* allowedMimeTypes formats
 * 1. *
 * 2. audio/wav
 * 3. image/*
 * 4. .mp4
 * 5. zip
 */
export function isAllowedMimeType(mimeType: string, allowedMimeTypes: string[]): boolean {
  for (const allowedType of allowedMimeTypes) {
    if (allowedType === '*') {
      return true;
    } else if (allowedType === mimeType) {
      return true;
    } else if (allowedType.endsWith('/*')) {
      const allowedPrefix = allowedType.split('/')[0];
      const mimePrefix = mimeType.split('/')[0];
      if (allowedPrefix === mimePrefix) {
        return true;
      }
    } else if (allowedType.startsWith('.')) {
      const allowedExtension = allowedType.slice(1);
      const mimeExtension = mimeType.split('/')[1];
      if (allowedExtension === mimeExtension) {
        return true;
      }
    } else {
      const mimeTypeExtension = mimeType.split('/')[1];
      if (mimeTypeExtension === allowedType) {
        return true;
      }
    }
  }
  return false;
}

export const getFileType = (file: File) => {
  const mimeType = file.type;
  const mimeTypeSplit = mimeType.split('/');
  if (mimeTypeSplit.length > 1) {
    if (mimeTypeSplit[0] === 'application' && mimeTypeSplit[1] === 'json') {
      return ModelInputFileAttachmentType.Json;
    } else if (mimeTypeSplit[0] === 'application' && mimeTypeSplit[1] === 'pdf') {
      return ModelInputFileAttachmentType.Pdf;
    }
  }
  if (mimeTypeSplit[0] === 'image') {
    return ModelInputFileAttachmentType.Image;
  }
  if (mimeTypeSplit[0] === 'text') {
    return ModelInputFileAttachmentType.Text;
  }
  if (mimeTypeSplit[0] === 'audio') {
    return ModelInputFileAttachmentType.Audio;
  }
  return null;
};
